import React, { useState, useEffect } from 'react';
import "./ScrollingList.css"

const PlayerList = ({ players }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const batchSize = 8;
  const delay = 8000; // 5 seconds

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        console.log(prevIndex)
        const nextIndex = (prevIndex + batchSize) % players.length;
        if((prevIndex + batchSize)>players.length){return 0}

        return nextIndex;
      });
    }, delay);

    return () => {
      clearInterval(intervalId);
    };
  }, [players.length]);

  const renderedPlayers = players.length <= batchSize ? players :players.slice(currentIndex, currentIndex + batchSize);



  return (
    <div style={{zIndex:3,minWidth:"25vw"}}>
        <div key={'heads'} className='header-item' style={{display:"flex",flexDirection:"row", }}>
        <div className='positionheader'>Position</div>
          <div className='nameheader'>Player</div>
          <div className='priceheader'>Price</div>
      </div>
      {renderedPlayers.map((player, index) => (
        <div key={index} className='list-item' style={{display:"flex",flexDirection:"row",border:"1px black solid",margin:"2px" }}>
          
          
           <div className='position'>{player.posicion}</div>
          <div className='name'>{player.nombre}</div>
          <div className='price'>{(player.premio === null || player.premio === "0" || player.premio === undefined) ? '' : '$' + player.premio
}</div>
        </div>
      ))}
    </div>
  );
};

export default PlayerList;
